function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var SaitoOverlay = require('../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var WithdrawalTemplate = require('./withdrawal.template');
var _require = require('../../web3-amount'),
  decimalIsPositive = _require.decimalIsPositive;
var _require2 = require('../../withdrawal'),
  SUPPORT_EMAIL = _require2.SUPPORT_EMAIL,
  SUPPORT_URL = _require2.SUPPORT_URL;
var WithdrawalOverlay = /*#__PURE__*/function () {
  function WithdrawalOverlay(app, mod) {
    _classCallCheck(this, WithdrawalOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(app, mod);
    this.ticker = '';
    this.eligible = '0';
    this.error = '';
    this.message = '';
    this.quote = null;
    this.prepared = null;
    this.statusText = 'Preparing your TRX withdrawal request.';
    this.submitting = false;
  }
  return _createClass(WithdrawalOverlay, [{
    key: "localAccount",
    value: function localAccount() {
      var _this$app$wallet, _this$app$wallet$retu, _crypto$isActivated, _crypto$options;
      var ticker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.ticker;
      var crypto = (_this$app$wallet = this.app.wallet) === null || _this$app$wallet === void 0 || (_this$app$wallet$retu = _this$app$wallet.returnCryptoModuleByTicker) === null || _this$app$wallet$retu === void 0 ? void 0 : _this$app$wallet$retu.call(_this$app$wallet, ticker);
      var activated = !!(crypto && ((_crypto$isActivated = crypto.isActivated) !== null && _crypto$isActivated !== void 0 && _crypto$isActivated.call(crypto) || (_crypto$options = crypto.options) !== null && _crypto$options !== void 0 && _crypto$options.isActivated || crypto.address));
      return {
        crypto: crypto,
        activated: activated,
        address: String((crypto === null || crypto === void 0 ? void 0 : crypto.address) || '')
      };
    }
  }, {
    key: "loadEligibleAmount",
    value: function loadEligibleAmount() {
      var _this$app,
        _this = this;
      var ticker = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.ticker;
      var peerKey = this.mod.store_public_key;
      if (!peerKey || !((_this$app = this.app) !== null && _this$app !== void 0 && (_this$app = _this$app.network) !== null && _this$app !== void 0 && _this$app.sendRequestAsTransaction)) {
        return Promise.resolve('0');
      }
      return new Promise(function (resolve) {
        _this.app.network.sendRequestAsTransaction('load-web3-proceeds', {
          module: 'Store'
        }, function (response) {
          var _response$eligible;
          var amount = response === null || response === void 0 || (_response$eligible = response.eligible) === null || _response$eligible === void 0 ? void 0 : _response$eligible[ticker];
          resolve(decimalIsPositive(amount) ? String(amount) : '0');
        }, peerKey);
      });
    }
  }, {
    key: "show",
    value: function show(state) {
      var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.overlay.show(WithdrawalTemplate(_objectSpread({
        state: state,
        ticker: this.ticker,
        eligible: this.eligible,
        error: this.error,
        message: this.message,
        statusText: this.statusText,
        supportEmail: SUPPORT_EMAIL,
        supportUrl: SUPPORT_URL
      }, extra)));
      this.attachEvents();
    }
  }, {
    key: "open",
    value: function () {
      var _open = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var ticker,
          _args = arguments;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              ticker = _args.length > 0 && _args[0] !== undefined ? _args[0] : '';
              this.ticker = String(ticker || '').trim().toUpperCase();
              this.error = '';
              this.eligible = '0';
              this.statusText = "Preparing your ".concat(this.ticker, " withdrawal request.");
              this.submitting = false;
              this.show('loading');
              _context.n = 1;
              return this.refresh();
            case 1:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function open() {
        return _open.apply(this, arguments);
      }
      return open;
    }()
  }, {
    key: "refresh",
    value: function () {
      var _refresh = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var account;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              _context2.n = 1;
              return this.loadEligibleAmount(this.ticker);
            case 1:
              this.eligible = _context2.v;
              if (decimalIsPositive(this.eligible)) {
                _context2.n = 2;
                break;
              }
              this.show('ineligible');
              return _context2.a(2);
            case 2:
              account = this.localAccount();
              if (!(!account.activated || !account.address)) {
                _context2.n = 3;
                break;
              }
              this.show('activate');
              return _context2.a(2);
            case 3:
              this.show('ready', {
                address: account.address
              });
            case 4:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function refresh() {
        return _refresh.apply(this, arguments);
      }
      return refresh;
    }()
  }, {
    key: "activateAccount",
    value: function () {
      var _activateAccount = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var _account$crypto;
        var account, activated, address, _t;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.p = _context3.n) {
            case 0:
              account = this.localAccount();
              if (!(typeof ((_account$crypto = account.crypto) === null || _account$crypto === void 0 ? void 0 : _account$crypto.activate) !== 'function')) {
                _context3.n = 1;
                break;
              }
              this.error = "A local ".concat(this.ticker, " account is not available in this wallet.");
              this.show('activate');
              return _context3.a(2);
            case 1:
              this.error = '';
              this.statusText = "Preparing your ".concat(this.ticker, " withdrawal request.");
              this.show('loading');
              activated = false;
              _context3.p = 2;
              _context3.n = 3;
              return account.crypto.activate();
            case 3:
              activated = _context3.v;
              _context3.n = 5;
              break;
            case 4:
              _context3.p = 4;
              _t = _context3.v;
              activated = false;
            case 5:
              address = String(account.crypto.address || '');
              if (!(!activated || !address)) {
                _context3.n = 6;
                break;
              }
              this.error = "Could not create a local ".concat(this.ticker, " account.");
              this.show('activate');
              return _context3.a(2);
            case 6:
              _context3.n = 7;
              return this.refresh();
            case 7:
              return _context3.a(2);
          }
        }, _callee3, this, [[2, 4]]);
      }));
      function activateAccount() {
        return _activateAccount.apply(this, arguments);
      }
      return activateAccount;
    }()
  }, {
    key: "requestFromStore",
    value: function requestFromStore(request, data) {
      var _this$app2,
        _this2 = this;
      var peerKey = this.mod.store_public_key;
      if (!peerKey || !((_this$app2 = this.app) !== null && _this$app2 !== void 0 && (_this$app2 = _this$app2.network) !== null && _this$app2 !== void 0 && _this$app2.sendRequestAsTransaction)) {
        return Promise.resolve({
          err: 'Store is not connected.'
        });
      }
      return new Promise(function (resolve) {
        _this2.app.network.sendRequestAsTransaction(request, data, function (response) {
          return resolve(response || {});
        }, peerKey);
      });
    }
  }, {
    key: "requestQuote",
    value: function () {
      var _requestQuote = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.p = _context4.n) {
            case 0:
              if (!this.submitting) {
                _context4.n = 1;
                break;
              }
              return _context4.a(2);
            case 1:
              this.submitting = true;
              _context4.p = 2;
              _context4.n = 3;
              return this.prepareAndSubmit();
            case 3:
              _context4.p = 3;
              this.submitting = false;
              return _context4.f(3);
            case 4:
              return _context4.a(2);
          }
        }, _callee4, this, [[2,, 3, 4]]);
      }));
      function requestQuote() {
        return _requestQuote.apply(this, arguments);
      }
      return requestQuote;
    }()
  }, {
    key: "prepareAndSubmit",
    value: function () {
      var _prepareAndSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _this$app$wallet$conv, _prepared;
        var account, quote, required, balance, prepared, text, outputs, _t2, _t3, _t4;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              account = this.localAccount();
              this.error = '';
              this.message = '';
              this.quote = null;
              this.prepared = null;
              this.statusText = 'Retrieving withdrawal details...';
              this.show('quoting');
              _context5.n = 1;
              return this.requestFromStore('store-withdrawal-quote', {
                module: 'Store',
                ticker: this.ticker,
                withdrawal_address: account.address
              });
            case 1:
              quote = _context5.v;
              if (!(quote !== null && quote !== void 0 && quote.err || !(quote !== null && quote !== void 0 && quote.data) || !(quote !== null && quote !== void 0 && quote.signature))) {
                _context5.n = 2;
                break;
              }
              this.error = (quote === null || quote === void 0 ? void 0 : quote.err) || 'The Store could not prepare a withdrawal quote.';
              this.show('failed');
              return _context5.a(2);
            case 2:
              required = BigInt((_this$app$wallet$conv = this.app.wallet.convertSaitoToNolan(quote.data.amount)) !== null && _this$app$wallet$conv !== void 0 ? _this$app$wallet$conv : 0);
              balance = 0n;
              _context5.p = 3;
              _t2 = BigInt;
              _context5.n = 4;
              return this.app.wallet.getBalance();
            case 4:
              balance = _t2(_context5.v);
              _context5.n = 6;
              break;
            case 5:
              _context5.p = 5;
              _t3 = _context5.v;
              balance = 0n;
            case 6:
              if (!(balance < required)) {
                _context5.n = 7;
                break;
              }
              this.show('insufficient');
              return _context5.a(2);
            case 7:
              prepared = null;
              _context5.p = 8;
              _context5.n = 9;
              return this.app.wallet.createUnsignedTransactionWithDefaultFee(quote.data.publickey, required);
            case 9:
              prepared = _context5.v;
              _context5.n = 12;
              break;
            case 10:
              _context5.p = 10;
              _t4 = _context5.v;
              text = (_t4 === null || _t4 === void 0 ? void 0 : _t4.message) || String(_t4 || '');
              if (!text.toLowerCase().includes('insufficient')) {
                _context5.n = 11;
                break;
              }
              this.show('insufficient');
              return _context5.a(2);
            case 11:
              this.error = text || 'The withdrawal transaction could not be prepared.';
              this.show('failed');
              return _context5.a(2);
            case 12:
              outputs = (((_prepared = prepared) === null || _prepared === void 0 ? void 0 : _prepared.to) || []).reduce(function (sum, slip) {
                try {
                  var _slip$amount;
                  return sum + BigInt((_slip$amount = slip === null || slip === void 0 ? void 0 : slip.amount) !== null && _slip$amount !== void 0 ? _slip$amount : 0);
                } catch (err) {
                  return sum;
                }
              }, 0n);
              if (!(!prepared || balance < outputs)) {
                _context5.n = 13;
                break;
              }
              this.prepared = null;
              this.show('insufficient');
              return _context5.a(2);
            case 13:
              prepared.msg = {
                module: 'Store',
                request: 'store-withdrawal',
                data: quote.data,
                signature: quote.signature
              };
              this.quote = quote;
              this.prepared = prepared;
              _context5.n = 14;
              return this.signAndSubmit();
            case 14:
              return _context5.a(2);
          }
        }, _callee5, this, [[8, 10], [3, 5]]);
      }));
      function prepareAndSubmit() {
        return _prepareAndSubmit.apply(this, arguments);
      }
      return prepareAndSubmit;
    }()
  }, {
    key: "signAndSubmit",
    value: function () {
      var _signAndSubmit = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6() {
        var serialized, result, _t5;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              if (!(!this.prepared || typeof this.prepared.sign !== 'function')) {
                _context6.n = 1;
                break;
              }
              this.error = 'The withdrawal request is not ready to sign.';
              this.show('failed');
              return _context6.a(2);
            case 1:
              this.statusText = 'Signing your Saito transaction...';
              this.show('signing');
              _context6.p = 2;
              _context6.n = 3;
              return this.prepared.sign();
            case 3:
              _context6.n = 5;
              break;
            case 4:
              _context6.p = 4;
              _t5 = _context6.v;
              this.error = (_t5 === null || _t5 === void 0 ? void 0 : _t5.message) || 'The withdrawal transaction was not signed.';
              this.show('failed');
              return _context6.a(2);
            case 5:
              serialized = typeof this.prepared.serialize_to_web === 'function' ? this.prepared.serialize_to_web(this.app) : '';
              this.statusText = 'Submitting your withdrawal request...';
              this.show('submitting');
              _context6.n = 6;
              return this.requestFromStore('store-withdrawal', {
                module: 'Store',
                transaction: serialized || this.prepared
              });
            case 6:
              result = _context6.v;
              if (!(!result || result.status == null && result.err == null && result.message == null)) {
                _context6.n = 7;
                break;
              }
              this.error = 'The Store did not confirm this request. It was not submitted again.';
              this.show('failed');
              return _context6.a(2);
            case 7:
              if (!((result === null || result === void 0 ? void 0 : result.status) === 'submitted')) {
                _context6.n = 8;
                break;
              }
              this.message = result.message || 'Withdrawal request submitted.';
              this.show('submitted');
              return _context6.a(2);
            case 8:
              if (!((result === null || result === void 0 ? void 0 : result.status) === 'accepted')) {
                _context6.n = 9;
                break;
              }
              this.message = result.message || 'Withdrawal request accepted by the Store. The external cryptocurrency has not been sent.';
              this.show('accepted');
              return _context6.a(2);
            case 9:
              this.error = (result === null || result === void 0 ? void 0 : result.err) || (result === null || result === void 0 ? void 0 : result.message) || 'The withdrawal request was not accepted.';
              this.message = (result === null || result === void 0 ? void 0 : result.message) || '';
              this.show('failed');
            case 10:
              return _context6.a(2);
          }
        }, _callee6, this, [[2, 4]]);
      }));
      function signAndSubmit() {
        return _signAndSubmit.apply(this, arguments);
      }
      return signAndSubmit;
    }()
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _root$querySelector,
        _this3 = this,
        _root$querySelector2;
      var root = document.querySelector('.store-withdrawal');
      if (!root) {
        return;
      }
      (_root$querySelector = root.querySelector('[data-action="activate-account"]')) === null || _root$querySelector === void 0 || _root$querySelector.addEventListener('click', function (e) {
        e.preventDefault();
        return _this3.activateAccount();
      });
      (_root$querySelector2 = root.querySelector('[data-action="confirm-withdraw"]')) === null || _root$querySelector2 === void 0 || _root$querySelector2.addEventListener('click', function (e) {
        e.preventDefault();
        return _this3.requestQuote();
      });
      root.addEventListener('submit', function (e) {
        e.preventDefault();
      });
    }
  }]);
}();
module.exports = WithdrawalOverlay;